import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import CategoryBranch from './treeBranch';

import style from './style.css';

const initialState = {};

@observer
class BrandLine extends Component {
    render() {
        const { stores, brand, queryFilter, onClickBrand } = this.props;
        const isSelectedBrand = queryFilter.brand === brand.brandno;
        return (
            <div class='nav-item'>
                <div class={`${style.pointerCursor} nav-link py-0 ${isSelectedBrand ? 'active' : ''}`}>
                    <span onClick={() => onClickBrand(brand.brandno)}>
                        {brand.name}
                        {brand.count && <span class='font-weight-lighter float-right'>({brand.count})</span>}
                    </span>
                </div>
                <div class={`d-${isSelectedBrand ? 'block' : 'none'} nav flex-column mt-1`}>
                    <CategoryBranch stores={stores} brand={brand.brandno} />
                </div>
            </div>
        );
    }
}

@observer
class BrandList extends Component {
    render() {
        const { stores, brands, queryFilter, onClickBrand } = this.props;
        return (
            <div>
                {brands.map(brand => <BrandLine stores={stores} brand={brand} queryFilter={queryFilter} onClickBrand={onClickBrand} />)}
            </div>
        );
    }
}

@observer
class CategoryTree extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };

        const { categoryStore, brandStore } = this.props.stores;
        const { queryFilter } = categoryStore;
        categoryStore.updateQueryFilter({
            level: queryFilter.level || 'all',
            brand: queryFilter.brand || 'all',
            status: queryFilter.status || 'all',
            parent: queryFilter.parent,
        });
        categoryStore.tree();

        brandStore.resetQueryFilter();
        brandStore.load();
    }

    onClickBrand = (brandno) => {
        const { categoryStore } = this.props.stores;
        categoryStore.toggleQueryfilter('parent', '', { setValue: 1, skipUpdate: 1 });
        categoryStore.toggleQueryfilter('level', '', { setValue: 1, skipUpdate: 1 });
        categoryStore.toggleQueryfilter('brand', brandno, { setValue: true });
    };

    render(props = this.props) {
        const { brandStore, categoryStore } = props.stores;
        const { brands } = brandStore;
        const { queryFilter } = categoryStore;

        return (
            <div class='nav flex-column nav-pills'>
                <BrandList stores={this.props.stores}
                    brands={brands}
                    queryFilter={queryFilter}
                    onClickBrand={this.onClickBrand}
                />
            </div>
        );
    }
}

export default CategoryTree;



// WEBPACK FOOTER //
// ./components/categories/tree.js